class CookieService {
    clearCookies() {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++)
            document.cookie =
                cookies[i] + '=;expires=' + new Date(0).toUTCString();
    }
}

export default CookieService;
